import React from 'react';
import PropTypes from 'prop-types';

const STRING_CELEBRATION_TITLE = "Congrats! You've successfully applied and created a profile!";
const STRING_EXPLAIN_PROFILE_CREATION_SIGNIFICANCE_DESCRIPTION = 'This profile will be viewed by employers with your application. It can also be viewed by employers on ZipRecruiter who are searching for candidates like you! Keep this profile up-to-date to improve your chances of getting hired.';
const STRING_CLICK = 'Click ';
const STRING_EDIT = 'edit ';
const STRING_MAKE_PROFILE_ACCOUNT_UPDATES = 'to make any necessary updates to your profile. You can also change your privacy settings below. If you like what you see, please ';
const STRING_CONTINUE_PERIOD = 'continue.';

export default function ProfileApprovalDefaultTitle({ headerPriority }) {
  const HTag = `h${headerPriority}`;
  return (
    <>
      <HTag className="title">{STRING_CELEBRATION_TITLE}</HTag>
      <p className="description">{STRING_EXPLAIN_PROFILE_CREATION_SIGNIFICANCE_DESCRIPTION}</p>
      <p className="description">
        {STRING_CLICK}
        <strong className="emphasis">{STRING_EDIT}</strong>
        {STRING_MAKE_PROFILE_ACCOUNT_UPDATES}
        <strong className="emphasis">{STRING_CONTINUE_PERIOD}</strong>
      </p>
    </>
  );
}

ProfileApprovalDefaultTitle.propTypes = {
  headerPriority: PropTypes.oneOf([1, 2, 3, 4, 5]),
};

ProfileApprovalDefaultTitle.defaultProps = {
  headerPriority: 4,
};
